module.exports = __webpack_public_path__ + "static/media/weatherDash.538c4097.png";